import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const CenterOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function CenterOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M10.61 10.59c.39-.37.89-.56 1.39-.56.5 0 1 .19 1.39.56.8.77.76 2.05-.03 2.83-.38.37-.87.55-1.36.55-.49 0-.98-.18-1.36-.55-.79-.78-.83-2.06-.03-2.83Z" />
          <path fillRule="evenodd" clipRule="evenodd" d="M13 0h-2v3.055A9.004 9.004 0 0 0 3.055 11H0v2h3.055A9.004 9.004 0 0 0 11 20.945V24h2v-3.055A9.004 9.004 0 0 0 20.945 13H24v-2h-3.055A9.004 9.004 0 0 0 13 3.055V0Zm6 12c0-3.86-3.14-7-7-7s-7 3.14-7 7 3.14 7 7 7 7-3.14 7-7Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default CenterOutlined;